import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/layout/index.vue"

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: '登录',
    hidden: true,
    component: () => import('@/views/login/index')
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  {
    path: '/cockpit',
    component: () => import('@/views/datacentre/datacenter/cockpit'),
    hidden: true
  },
  {
    path: '/labour',
    component: () => import('@/views/constructionsite/constructionsites/labour'),
    hidden: true
  },
  {
    path: '/detail',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'searchmsg',
        component: () => import('@/views/datacentre/datacenter/searchmsg'),
        name: 'searchmsg',
        meta: { title: '搜索' }
      },
      {
        path: 'addctosite',
        component: () => import('@/views/constructionsite/constructionsites/addctosite'),
        name: 'addctosite',
        meta: { title: '新增工地' }
      },
      {
        path: 'addequipment',
        component: () => import('@/views/equipmentmsg/equipmentmsgs/addequipment'),
        name: 'addequipment',
        meta: { title: '新增设备' }
      },
      {
        path: 'dtlequipment',
        component: () => import('@/views/equipmentmsg/equipmentmsgs/dtlequipment'),
        name: 'dtlequipment',
        meta: { title: '详情设备' }
      },
      {
        path: 'dtlparameter',
        component: () => import('@/views/equipmentmsg/equipmentmsgs/dtlparameter'),
        name: 'dtlparameter',
        meta: { title: '设备参数详情' }
      },
      {
        path: 'dtlmalfunction',
        component: () => import('@/views/equipmentmsg/equipmentmsgs/dtlmalfunction'),
        name: 'dtlmalfunction',
        meta: { title: '故障记录详情' }
      },
      {
        path: 'addmalfunction',
        component: () => import('@/views/malfunction/malfunctions/addmalfunction'),
        name: 'addmalfunction',
        meta: { title: '故障记录新增' }
      },
      {
        path: 'dtlmaintenances',
        component: () => import('@/views/equipmentmsg/equipmentmsgs/dtlmaintenances'),
        name: 'dtlmaintenances',
        meta: { title: '维保记录详情' }
      },
      {
        path: 'dtlremark',
        component: () => import('@/views/equipmentmsg/equipmentmsgs/dtlremark'),
        name: 'dtlremark',
        meta: { title: '备注详情' }
      },
      {
        path: 'addmaintenance',
        component: () => import('@/views/equipmentmsg/equipmentmsgs/addmaintenance'),
        name: 'addmaintenance',
        meta: { title: '维保记录新增' }
      },
      {
        path: 'dilmaintenance',
        component: () => import('@/views/equipmentmsg/equipmentmsgs/dilmaintenance'),
        name: 'dilmaintenance',
        meta: { title: '设备维保记录新增' }
      },
      {
        path: 'addoutlibrary',
        component: () => import('@/views/inoutlibrary/inoutlibrarys/addoutlibrary'),
        name: 'addoutlibrary',
        meta: { title: '新增出库' }
      },
      {
        path: 'addinlibrary',
        component: () => import('@/views/inoutlibrary/inoutlibrarys/addinlibrary'),
        name: 'addinlibrary',
        meta: { title: '新增入库' }
      },
      {
        path: 'personal',
        component: () => import('@/views/personal/personal'),
        name: 'personal',
        meta: { title: '个人中心' }
      },
      {
        path: 'informations',
        component: () => import('@/views/personal/informations'),
        name: 'informations',
        meta: { title: '消息通知' }
      },
    ]
  },
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [

]

// 公共路由
export const constantRoutes  = routes

document.title = '众科机械'
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  // mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
